import { IdNamePair } from './id-name-pair';

export enum JobStatus {
  Pending = 1,
  Running = 2,
  Complete = 3,
  Error = 4
}

export class JobType extends IdNamePair {}

export class Job {
  CreatedBy: string;
  CreatedOn: Date;
  ErrorDescription: string;
  Id: number;
  Status: JobStatus;
  Type: JobType;
}

export class AchFraudScan extends Job {
  FileId: string;
}
